import { useState } from 'react'

import { submitPhoto } from '../lib/data.js'
import { TEST_PHOTO_TOURNAMENT_ID } from '../lib/teststation.js'
import useWakeLock from '../lib/useWakeLock.js'
import CLUB from '../config/club.js'

// Phone capture page. The user taps "Take Photo" → browser opens the
// camera (capture="environment"); on selection we upload through the same
// submitPhoto helper used by /photos, just pinned to the fixed
// TEST_PHOTO_TOURNAMENT_ID and submitted with role=admin so it lands
// auto-approved on /testphotowall without a review step.
export default function TestPhoto() {
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [count, setCount] = useState(0)
  useWakeLock(true)

  const onPick = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setBusy(true); setErr('')
    try {
      await submitPhoto(TEST_PHOTO_TOURNAMENT_ID, file, {
        submitterRole: 'admin',
        submittedBy: 'Test Phone',
        caption: 'test',
      })
      setCount((c) => c + 1)
    } catch (e2) {
      setErr(e2?.message || String(e2))
    } finally {
      setBusy(false)
      e.target.value = ''
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh', backgroundColor: CLUB.backgroundColor || 'var(--ge-primary)',
        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 11, letterSpacing: 2, color: CLUB.accentColor, fontWeight: 800 }}>
            🧪 PHOTO WALL TEST
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 800, margin: '6px 0 0' }}>Submit a photo</h1>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 4 }}>
            Photos appear instantly on every open <strong>/testphotowall</strong> screen.
          </p>
        </div>

        <label
          htmlFor="testphoto-input"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            width: '100%', padding: '20px 16px', borderRadius: 14,
            background: busy ? 'rgba(255,255,255,0.15)' : CLUB.accentColor,
            color: busy ? 'rgba(255,255,255,0.5)' : 'var(--ge-primary)',
            fontSize: 18, fontWeight: 900, letterSpacing: 1,
            cursor: busy ? 'wait' : 'pointer',
            border: 'none',
          }}>
          {busy ? '⏳ UPLOADING…' : '📷 TAKE PHOTO'}
        </label>
        <input
          id="testphoto-input"
          type="file"
          accept="image/*"
          capture="environment"
          onChange={onPick}
          disabled={busy}
          style={{ display: 'none' }} />

        <div style={{ marginTop: 18, padding: 14, borderRadius: 12, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)' }}>
          <div style={{ fontSize: 11, letterSpacing: 1, color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>
            UPLOADED THIS SESSION
          </div>
          <div style={{ fontSize: 26, fontWeight: 900, marginTop: 2 }}>
            {count}
          </div>
        </div>
        {err ? (
          <div style={{ marginTop: 12, padding: 10, borderRadius: 8, background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.45)', fontSize: 12, color: '#FCA5A5' }}>
            {err}
          </div>
        ) : null}
        <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', marginTop: 16, textAlign: 'center', letterSpacing: 1 }}>
          pbccgolf.com/testphoto
        </p>
      </div>
    </div>
  )
}
